export const environment = {
  production: true,
  buildId: '3731289798623231',
  configFile: 'config.json',
};
